/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Week {
  baseApi = ENV.BASE_API;

  async getWeeksBySubject(accessToken, syllabuSubjectGradeId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}/getWeeksBySubject/${syllabuSubjectGradeId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getWeeksBySubjectForStudent(accessToken, syllabuSubjectGradeId,studentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}/getWeeksBySubjectForStudent/${syllabuSubjectGradeId}?studentId=${studentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createWeek(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateWeek(accessToken, weekId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}/${weekId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteWeek(accessToken, weekId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}/${weekId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateIndexWeeks(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.WEEK}/updateIndexWeeks`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
